// in the same order as in assignmentTabs array
export enum TabKeys {
  TypeSelector = 0,
  WorkerInfo = 1,
  CustomerInfo = 2,
  WorksiteLocation = 3,
  AssignmentInfo = 4,
  FinancialInfo = 5,
  SplitInfo = 6,
}
